<template>
  <div>
    <div class="faq-title">
      <h1 class="faq-title-main">FAQ</h1>
      <p class="faq-title-sub">よくあるお問い合わせ</p>
    </div>
    <div class="faq-area">
      <div class="faq-content" v-for="faq in faqContent" :key="faq.question">
        <div class="question">
          Q.{{ faq.question }}
        </div>
        <div class="answer">
          A.<span v-html=faq.answer></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'app',
  components: {
    // なし
  },
  data:function(){
    return{
      faqContent:[
        {
          question:'施術当日の入浴はできますか？',
          answer:`はい、可能です。`
        },
        {
          question:'痛みはありますか？',
          answer:`基本的にはありません。ただ、骨の近くや皮膚が薄いところなどは痛みが出る場合があります。
パワーの調整はできるので、無理をしすぎない強さで行ってください。`
        },
        {
          question:'どのくらいの頻度で通えばいいですか？',
          answer:`部位によりますが、2~3週間に一度程度の施術をおすすめさせていただいております。ただ、
部位によっては一定期間空けないと施術を行えない場合がございます。`
        },
        {
          question:'生理中の施術はできますか？',
          answer:`生理中はむくみやすく溜め込みやすいため、効果が出にくい場合がございます。
また、肌が敏感になっているため赤みなどが出やすい場合がございますので、当店では
生理以外のお日にちでの施術をおすすめしております。`
        },
        {
          question:'どのくらい通えばいいですか？',
          answer:`お客様の目標に合わせて好きなだけ通っていただけます。`
        },
        {
          question:'ダウンタイムなどはありますか？',
          answer:`施術後にトラブルが起きにくいこともセルフエステエンリケの強みの一つです。
ただ、パワーや部位によっては施術後に赤みなどが出る可能性があります。施術後に違和感がありましたら
施術を行った店舗にお問い合わせください。`
        },
        {
          question:'予約はどこから行えばいいですか？',
          answer:`ホットペッパーか、店舗に直接お問い合わせください。`
        },
        {
          question:'当日飛び入りで行っても大丈夫でしょうか。',
          answer:`はい、大丈夫です。予約無しでも気軽にご来店していただけます。`
        },
        {
          question:'単品プランで通い続けることは可能ですか？',
          answer:`可能です。ですが、長期通っていただくなら定額のサブスクプランの方がかなりお得になっていますので
サブスクプランで通われることをオススメいたします。`
        },
        {
          question:'施術後、食事は可能ですか？',
          answer:`基本的には問題ありません。ただ、吸収がかなり良くなっているため施術直後の食事はできるだけ
控えていただいた方が効果を実感できます。逆にビタミン剤やタンパク質なら効率的に摂取できます。`
        },
      ]
    }
  }
}
</script>

<style>
  @import "../../css/style.css";

  .mg-t-50{
    margin-top: 50px;
  }

  .faq-area{
    background-color: var(--main-color);
    padding: 30px 0;
  }

  /* PC表示 */
  @media screen and (min-width:821px){
    .faq-title{
      color: var(--main-color);
      text-align: center;
      margin: 50px auto;
    }

    .faq-title-main{
      font-size: 2.5rem;
      letter-spacing: 0.2em;
    }

    .faq-title-sub{
      font-size: 1rem;
      margin-top: 0.5em;
    }

    .faq-content{
      width: 80vw;
      background-color: white;
      left: 0;
      right: 0;
      padding: 20px 15px;
      margin: 20px auto;

      white-space: pre-wrap;
    }

    .question{
      width: 80%;
      color: var(--main-color);
      font-weight: 600;
      border-bottom: solid 1px var(--main-color);
      padding-bottom: 10px;
    }

    .answer{
      min-height: 2em;
      color: var(--main-color);
      font-size: 14px;
      margin-top: 10px;

      line-height: 1.5em;
    }
  }
  /* スマホ表示 */
  @media screen and (max-width:820px){
    .faq-title{
      color: var(--main-color);
      text-align: center;
      padding-top: 50px;
      padding-bottom: 20px;
    }

    .faq-title-main{
      font-size: 5vw;
      letter-spacing: 0.2em;
    }

    .faq-title-sub{
      font-size: 2vw;
      margin-top: 1em;
    }

    .faq-content{
      width: 85vw;
      background-color: white;
      left: 0;
      right: 0;
      padding: 20px 15px;
      margin: 20px auto;

      white-space: pre-wrap;
    }

    .question{
      font-size: 14px;
      width: 80%;
      color: var(--main-color);
      font-weight: 600;
      border-bottom: solid 1px var(--main-color);
      padding-bottom: 10px;
    }

    .answer{
      min-height: 2em;
      color: var(--main-color);
      font-size: 10px;
      margin-top: 10px;

      line-height: 1.5em;
    }
  }
</style>